import { dew as _dateDew } from "./date";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.date = void 0;
  var date_1 = _dateDew();
  Object.defineProperty(exports, "date", {
    enumerable: true,
    get: function () {
      return date_1.date;
    }
  });
  return exports;
}